import axios from 'axios';
import URI from 'urijs';
const getPmdcAxiosInstance = function (accessToken, axiosOptions) {
  let directory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/v1';
  const baseURL = URI(window.processRuntime.env?.API_URL).directory(directory).toString();
  return axios.create({
    baseURL,
    ...axiosOptions,
    headers: {
      ...(accessToken && {
        Authorization: `Bearer ${accessToken}`
      } || {}),
      ...(axiosOptions && axiosOptions.headers || {})
    }
  });
};
export default getPmdcAxiosInstance;